export class PreLoginPeticion {
    public codCliente: string;
    public urlPortal: string;
}